/** Layout header, referral link title, stop-loss how-it-works (per-plan flow). */
export const panelStopLossHowLayoutByLang = {
  es: {
    'user.layout.portfolioWorkspace': 'Espacio de cartera',
    'user.referral.link.title': 'Tu enlace de referido',
    'user.stopLoss.activePackages': 'Paquetes Stop-Loss activos',
    'user.stopLoss.how.title': 'Cómo funciona Stop-Loss',
    'user.stopLoss.how.step1Title': 'Elige tu plan',
    'user.stopLoss.how.step1Desc':
      'Elige qué inversión activa proteger — un stop-loss por plan, tarifa igual al monto del plan',
    'user.stopLoss.how.step2Title': 'Aplicar protección',
    'user.stopLoss.how.step2Desc':
      'Selecciona el paquete stop-loss correspondiente — la protección se aplica a ese plan de inmediato',
    'user.stopLoss.how.step3Title': 'Supervisión 24/7',
    'user.stopLoss.how.step3Desc': 'El sistema supervisa continuamente el valor de tu inversión',
    'user.stopLoss.how.step4Title': 'Disparo automático',
    'user.stopLoss.how.step4Desc': 'La inversión se detiene sola si el valor cruza tu umbral',
  },
  de: {
    'user.layout.portfolioWorkspace': 'Portfolio-Arbeitsbereich',
    'user.referral.link.title': 'Ihr Empfehlungslink',
    'user.stopLoss.activePackages': 'Aktive Stop-Loss-Pakete',
    'user.stopLoss.how.title': 'So funktioniert Stop-Loss',
    'user.stopLoss.how.step1Title': 'Plan wählen',
    'user.stopLoss.how.step1Desc':
      'Aktive Investition wählen — ein Stop-Loss pro Plan, Gebühr = Planbetrag',
    'user.stopLoss.how.step2Title': 'Schutz anwenden',
    'user.stopLoss.how.step2Desc':
      'Passendes Stop-Loss-Paket wählen — der Schutz wird sofort auf diesen Plan angewendet',
    'user.stopLoss.how.step3Title': '24/7-Überwachung',
    'user.stopLoss.how.step3Desc': 'Das System überwacht kontinuierlich den Wert Ihrer Investition',
    'user.stopLoss.how.step4Title': 'Auto-Auslösung',
    'user.stopLoss.how.step4Desc':
      'Die Investition stoppt automatisch, wenn der Wert Ihre Schwelle überschreitet',
  },
  fr: {
    'user.layout.portfolioWorkspace': 'Espace portefeuille',
    'user.referral.link.title': 'Votre lien de parrainage',
    'user.stopLoss.activePackages': 'Forfaits Stop-Loss actifs',
    'user.stopLoss.how.title': 'Comment fonctionne le Stop-Loss',
    'user.stopLoss.how.step1Title': 'Choisissez votre plan',
    'user.stopLoss.how.step1Desc':
      'Choisissez l’investissement actif à protéger — un stop-loss par plan, frais = montant du plan',
    'user.stopLoss.how.step2Title': 'Appliquer la protection',
    'user.stopLoss.how.step2Desc':
      'Sélectionnez le forfait stop-loss correspondant — la protection est appliquée à ce plan immédiatement',
    'user.stopLoss.how.step3Title': 'Surveillance 24/7',
    'user.stopLoss.how.step3Desc': 'Le système surveille en continu la valeur de votre investissement',
    'user.stopLoss.how.step4Title': 'Déclenchement auto',
    'user.stopLoss.how.step4Desc':
      'L’investissement s’arrête automatiquement si la valeur franchit votre seuil',
  },
  ar: {
    'user.layout.portfolioWorkspace': 'مساحة المحفظة',
    'user.referral.link.title': 'رابط الإحالة الخاص بك',
    'user.stopLoss.activePackages': 'حزم وقف الخسارة النشطة',
    'user.stopLoss.how.title': 'كيف يعمل وقف الخسارة',
    'user.stopLoss.how.step1Title': 'اختر خطتك',
    'user.stopLoss.how.step1Desc':
      'اختر الاستثمار النشط الذي تريد حمايته — وقف خسارة واحد لكل خطة، الرسوم = مبلغ الخطة',
    'user.stopLoss.how.step2Title': 'تطبيق الحماية',
    'user.stopLoss.how.step2Desc':
      'اختر باقة وقف الخسارة المناسبة — تُطبَّق الحماية على تلك الخطة فوراً',
    'user.stopLoss.how.step3Title': 'مراقبة 24/7',
    'user.stopLoss.how.step3Desc': 'يراقب النظام قيمة استثمارك باستمرار',
    'user.stopLoss.how.step4Title': 'تشغيل تلقائي',
    'user.stopLoss.how.step4Desc': 'يتوقف الاستثمار تلقائياً عند تجاوز القيمة لعتبتك',
  },
  ja: {
    'user.layout.portfolioWorkspace': 'ポートフォリオワークスペース',
    'user.referral.link.title': 'あなたの紹介リンク',
    'user.stopLoss.activePackages': '有効なストップロスパッケージ',
    'user.stopLoss.how.title': 'ストップロスの仕組み',
    'user.stopLoss.how.step1Title': 'プランを選択',
    'user.stopLoss.how.step1Desc':
      '保護するアクティブな投資を選ぶ — プランごとに1つのストップロス、手数料はプラン金額と同額',
    'user.stopLoss.how.step2Title': '保護を適用',
    'user.stopLoss.how.step2Desc':
      '該当するストップロスパッケージを選ぶ — そのプランにすぐ保護が適用されます',
    'user.stopLoss.how.step3Title': '24時間365日の監視',
    'user.stopLoss.how.step3Desc': 'システムが投資価値を継続的に監視します',
    'user.stopLoss.how.step4Title': '自動発動',
    'user.stopLoss.how.step4Desc': '価値がしきい値を超えると投資は自動停止します',
  },
  ko: {
    'user.layout.portfolioWorkspace': '포트폴리오 워크스페이스',
    'user.referral.link.title': '내 추천 링크',
    'user.stopLoss.activePackages': '활성 스톱로스 패키지',
    'user.stopLoss.how.title': '스톱로스 작동 방식',
    'user.stopLoss.how.step1Title': '플랜 선택',
    'user.stopLoss.how.step1Desc':
      '보호할 활성 투자를 선택 — 플랜당 스톱로스 하나, 수수료는 플랜 금액과 동일',
    'user.stopLoss.how.step2Title': '보호 적용',
    'user.stopLoss.how.step2Desc':
      '해당 스톱로스 패키지를 선택 — 해당 플랜에 즉시 보호가 적용됩니다',
    'user.stopLoss.how.step3Title': '24/7 모니터링',
    'user.stopLoss.how.step3Desc': '시스템이 투자 가치를 지속적으로 모니터링합니다',
    'user.stopLoss.how.step4Title': '자동 발동',
    'user.stopLoss.how.step4Desc': '가치가 임계값을 넘으면 투자가 자동 중지됩니다',
  },
  pt: {
    'user.layout.portfolioWorkspace': 'Área de portfólio',
    'user.referral.link.title': 'O seu link de indicação',
    'user.stopLoss.activePackages': 'Pacotes Stop-Loss ativos',
    'user.stopLoss.how.title': 'Como funciona o Stop-Loss',
    'user.stopLoss.how.step1Title': 'Escolha o seu plano',
    'user.stopLoss.how.step1Desc':
      'Escolha qual investimento ativo proteger — um stop-loss por plano, taxa igual ao valor do plano',
    'user.stopLoss.how.step2Title': 'Aplicar proteção',
    'user.stopLoss.how.step2Desc':
      'Selecione o pacote stop-loss correspondente — a proteção é aplicada a esse plano imediatamente',
    'user.stopLoss.how.step3Title': 'Monitorização 24/7',
    'user.stopLoss.how.step3Desc': 'O sistema monitoriza continuamente o valor do seu investimento',
    'user.stopLoss.how.step4Title': 'Disparo automático',
    'user.stopLoss.how.step4Desc':
      'O investimento para automaticamente se o valor ultrapassar o seu limiar',
  },
  it: {
    'user.layout.portfolioWorkspace': 'Area portafoglio',
    'user.referral.link.title': 'Il tuo link di referral',
    'user.stopLoss.activePackages': 'Pacchetti Stop-Loss attivi',
    'user.stopLoss.how.title': 'Come funziona lo Stop-Loss',
    'user.stopLoss.how.step1Title': 'Scegli il tuo piano',
    'user.stopLoss.how.step1Desc':
      'Scegli quale investimento attivo proteggere — uno stop-loss per piano, commissione = importo del piano',
    'user.stopLoss.how.step2Title': 'Applica protezione',
    'user.stopLoss.how.step2Desc':
      'Seleziona il pacchetto stop-loss corrispondente — la protezione viene applicata subito a quel piano',
    'user.stopLoss.how.step3Title': 'Monitoraggio 24/7',
    'user.stopLoss.how.step3Desc': 'Il sistema monitora continuamente il valore del tuo investimento',
    'user.stopLoss.how.step4Title': 'Attivazione automatica',
    'user.stopLoss.how.step4Desc':
      'L’investimento si interrompe automaticamente se il valore supera la soglia',
  },
  ru: {
    'user.layout.portfolioWorkspace': 'Рабочая область портфеля',
    'user.referral.link.title': 'Ваша реферальная ссылка',
    'user.stopLoss.activePackages': 'Активные пакеты стоп-лосс',
    'user.stopLoss.how.title': 'Как работает стоп-лосс',
    'user.stopLoss.how.step1Title': 'Выберите план',
    'user.stopLoss.how.step1Desc':
      'Выберите активную инвестицию для защиты — один стоп-лосс на план, комиссия равна сумме плана',
    'user.stopLoss.how.step2Title': 'Применить защиту',
    'user.stopLoss.how.step2Desc':
      'Выберите подходящий пакет стоп-лосс — защита сразу применяется к этому плану',
    'user.stopLoss.how.step3Title': 'Мониторинг 24/7',
    'user.stopLoss.how.step3Desc': 'Система постоянно отслеживает стоимость вашей инвестиции',
    'user.stopLoss.how.step4Title': 'Автосрабатывание',
    'user.stopLoss.how.step4Desc':
      'Инвестиция автоматически останавливается, если стоимость пересекает порог',
  },
  bn: {
    'user.layout.portfolioWorkspace': 'পোর্টফোলিও ওয়ার্কস্পেস',
    'user.referral.link.title': 'আপনার রেফারেল লিঙ্ক',
    'user.stopLoss.activePackages': 'সক্রিয় স্টপ-লস প্যাকেজ',
    'user.stopLoss.how.title': 'স্টপ-লস কীভাবে কাজ করে',
    'user.stopLoss.how.step1Title': 'আপনার প্ল্যান বেছে নিন',
    'user.stopLoss.how.step1Desc':
      'কোন সক্রিয় বিনিয়োগ সুরক্ষিত করবেন তা বেছে নিন — প্ল্যান প্রতি একটি স্টপ-লস, ফি = প্ল্যানের পরিমাণ',
    'user.stopLoss.how.step2Title': 'সুরক্ষা প্রয়োগ করুন',
    'user.stopLoss.how.step2Desc':
      'মিলিয়ে স্টপ-লস প্যাকেজ বেছে নিন — সুরক্ষা সঙ্গে সঙ্গে সেই প্ল্যানে প্রয়োগ হয়',
    'user.stopLoss.how.step3Title': '২৪/৭ পর্যবেক্ষণ',
    'user.stopLoss.how.step3Desc': 'সিস্টেম ক্রমাগত আপনার বিনিয়োগের মূল্য পর্যবেক্ষণ করে',
    'user.stopLoss.how.step4Title': 'স্বয়ংক্রিয় ট্রিগার',
    'user.stopLoss.how.step4Desc': 'মূল্য সীমা অতিক্রম করলে বিনিয়োগ স্বয়ংক্রিয়ভাবে বন্ধ হয়',
  },
  hi: {
    'user.layout.portfolioWorkspace': 'पोर्टफ़ोलियो वर्कस्पेस',
    'user.referral.link.title': 'आपका रेफ़रल लिंक',
    'user.stopLoss.activePackages': 'सक्रिय स्टॉप-लॉस पैकेज',
    'user.stopLoss.how.title': 'स्टॉप-लॉस कैसे काम करता है',
    'user.stopLoss.how.step1Title': 'अपनी योजना चुनें',
    'user.stopLoss.how.step1Desc':
      'किस सक्रिय निवेश की सुरक्षा करनी है चुनें — प्रति योजना एक स्टॉप-लॉस, शुल्क = योजना राशि',
    'user.stopLoss.how.step2Title': 'सुरक्षा लागू करें',
    'user.stopLoss.how.step2Desc':
      'मिलता-जुलता स्टॉप-लॉस पैकेज चुनें — सुरक्षा तुरंत उस योजना पर लागू होती है',
    'user.stopLoss.how.step3Title': '24/7 निगरानी',
    'user.stopLoss.how.step3Desc': 'सिस्टम लगातार आपके निवेश मूल्य की निगरानी करता है',
    'user.stopLoss.how.step4Title': 'ऑटो-ट्रिगर',
    'user.stopLoss.how.step4Desc': 'मूल्य सीमा पार करने पर निवेश स्वतः रुक जाता है',
  },
  'zh-CN': {
    'user.layout.portfolioWorkspace': '投资组合工作区',
    'user.referral.link.title': '您的推荐链接',
    'user.stopLoss.activePackages': '有效的止损套餐',
    'user.stopLoss.how.title': '止损如何运作',
    'user.stopLoss.how.step1Title': '选择您的计划',
    'user.stopLoss.how.step1Desc':
      '选择要保护哪项进行中的投资 — 每个计划一项止损，费用等于计划金额',
    'user.stopLoss.how.step2Title': '应用保护',
    'user.stopLoss.how.step2Desc':
      '选择匹配的止损套餐 — 保护会立即应用到该计划',
    'user.stopLoss.how.step3Title': '全天候监控',
    'user.stopLoss.how.step3Desc': '系统持续监控您的投资价值',
    'user.stopLoss.how.step4Title': '自动触发',
    'user.stopLoss.how.step4Desc': '价值越过您设定的阈值时，投资将自动停止',
  },
};
